import { FC } from "react";
import { useTranslation } from "react-i18next";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker, DateTimePickerProps } from "@mui/x-date-pickers";
import { AppConstant } from "@/const";

interface InputDateProps extends DateTimePickerProps<Date> {
  format?: string;
}

const InputDate: FC<InputDateProps> = ({ label, ...otherProps }) => {
  const { t: getLabel } = useTranslation();
  const inputLabel = label || getLabel("L_DATETIME");

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimePicker
        label={inputLabel}
        slotProps={{
          textField: { fullWidth: true },
          actionBar: { actions: ["clear", "accept"] },
        }}
        {...otherProps}
      />
    </LocalizationProvider>
  );
};

InputDate.defaultProps = {
  format: AppConstant.FM_FULL_DATE,
};

export default InputDate;
